<template>
	<div class="order">
		<div class="header-box">
			<div class="query-box">
				<el-input size="medium" v-model="keyword" placeholder="请输入关键字" clearable></el-input>
				<el-button type="info" size="medium" @click="queryHandle">查询</el-button>
			</div>
			<el-button type="info" size="medium" @click="$router.go(-1)">取消</el-button>
		</div>
		<div class="table">
			<el-table :data="tableData" stripe style="width: 100%">
				<el-table-column type="index" align="center" label="序号"></el-table-column>
				<el-table-column prop="title" align="center" label="设备信息"></el-table-column>
				<el-table-column prop="addTime" align="center" label="上传时间"></el-table-column>
				<el-table-column prop="emergencyPrice" align="center" label="租赁价格"></el-table-column>
				<el-table-column prop="" align="center" label="设备状态">
					<template scope="{row}">
						{{'正常'}}
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template scope="{row}">
						<div class="" v-if="type == 1">
							<span style="cursor: pointer;color: #55aa7f;" @click="useHandle(row)">使用</span>
						</div>
						<div class="" v-if="type == 2">
							<span style="cursor: pointer;color: #55aa7f;" @click="useHandle1(row)">使用</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page-pager">
			<el-pagination background layout="total, prev, pager, next" :total="total" :pager-count="11"
				:page-size="pagesize" :current-page="currentPage" :current-change="pageChange"></el-pagination>
		</div>
	</div>
</template>

<script>
	import {
		equipmentList,
		updateOrder,
		updateOrderEq,
		updateOrderDEq
	} from '../../http/factory/add-eme.js';
	export default {
		name: 'order',
		data() {
			return {
				total: 0,
				pagesize: 12,
				currentPage: 1,
				tableData: [],
				keyword: null
			};
		},
		created() {
			this.equId = this.$route.query.equId
			this.orderId = this.$route.query.orderId
			this.factoryId = this.$route.query.factoryId
			this.type = this.$route.query.type
			this.getList()
		},
		methods: {
			useHandle(row) {
				updateOrderEq({
					id: this.orderId,
					equipmentId: row.id
				}).then(res => {
					this.$message({
						message: '修改成功',
						type: 'success'
					});
					this.$router.go(-1)
				})
			},
			useHandle1(row) {
				updateOrderDEq({
					id: this.orderId,
					equipmentsId: this.equId,
					equipmentId: row.id
				}).then(res => {
					this.$message({
						message: '修改成功',
						type: 'success'
					});
					this.$router.go(-1)
				})
			},
			queryHandle() {
				this.getList()
			},
			getList() {
				equipmentList({
					businessId: this.factoryId,
					serviceType: 0,
					pageSize: this.pagesize,
					pageNum: this.currentPage,
					title: this.keyword
				}).then(res => {
					this.tableData = res.rows
					this.total = res.total
				})
			},
			pageChange() {
				this.currentPage = e;
			},
			changeTable(index) {
				this.categoryIndex = index
				this.currentPage = 1
				this.fetchData()
			},
			hanldeCheck(row) {
				this.$router.push({
					path: '/factoryUser/factoryDetailEme',
					query: {
						id: row.id
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
	.order {
		width: 100%;
		background: @vue-bg-color;

		.header-box {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 20px;

			.query-box {
				display: flex;
				align-items: center;
				justify-content: start;
			}
		}

		.table {
			width: 100%;
			padding: @vue-spacing-col-base @vue-spacing-row-base;
			box-sizing: border-box;

			.table-order-status {
				span {
					color: @vue-text-color-red;
				}
			}
		}

		.page-pager {
			width: 100%;
			height: 50px;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding: 0px @vue-spacing-row-lg;
			box-sizing: border-box;
		}
	}
</style>
